import WalletSearch from "./WalletSearch";

export default WalletSearch;